import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {TableComponent} from '../../../../components/table/table.component';
import {IfHasAllPermissionsDirective} from '../../../../directives/if-has-all-permissions.directive';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {PERMISSION} from '@generated-backend-types';

@Component({
  selector: 'app-authenticated-time-tracking-absence-requests-personal',
  templateUrl: './personal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TableComponent,
    IfHasAllPermissionsDirective,
    RouterLink,
    TranslatePipe
  ]
})
export class PersonalComponent extends AuthenticatedBaseComponent implements OnInit {
  protected readonly PERMISSION = PERMISSION;

  public ngOnInit() {
    this.titleService.setTitle('authenticated.time_tracking.absence_requests.personal.title');
  }
}
